// Kompakte Nachrichten-Vorschau für Suche, Lesezeichen und Erinnerungen (reiner Text – kein HTML aus der API).
import type { MessageDto } from '@lagerfeuer/shared';
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { messageLink } from './api';
import { displayName, formatDateTime } from './format';
import { renderHighlight } from './highlight';
import { Badge } from './ui';
import { sameOriginUrl } from './safe-url';

export function MessagePreview(props: {
  message: MessageDto;
  highlight?: string;
  channelName?: string | null;
  mirrored?: boolean;
  testId?: string;
  actions?: ReactNode;
  /** Link zur Nachricht anzeigen (Standard: ja). */
  jump?: boolean;
}) {
  const m = props.message;
  const name = m.overrideName ?? m.member?.nickname ?? displayName(m.author);
  const avatar = sameOriginUrl(m.overrideAvatarUrl ?? m.member?.serverAvatarUrl ?? m.author?.avatarUrl ?? null);
  const attachments = m.attachments.length;
  return (
    <article className="lfx-msg" data-testid={props.testId ?? 'extras-message'} data-message-id={m.id}>
      {avatar ? <img className="lfx-msg__avatar" src={avatar} alt="" /> : <div className="lfx-msg__avatar" aria-hidden="true" />}
      <div className="lfx-grow">
        <div className="lfx-msg__meta">
          <span className="lfx-msg__author">{name}</span>
          {props.channelName && <span className="lfx-muted">#{props.channelName}</span>}
          <time className="lfx-muted" dateTime={m.createdAt}>
            {formatDateTime(m.createdAt)}
          </time>
          {(m.bridged || props.mirrored) && (
            <Badge tone="mirror" testId="extras-mirrored-badge" title="Aus einem gespiegelten Discord-Server">
              gespiegelt
            </Badge>
          )}
          {m.pinned && <Badge>angeheftet</Badge>}
        </div>
        <div className="lfx-msg__content">
          {m.deleted ? <em className="lfx-muted">Nachricht gelöscht</em> : props.highlight ? renderHighlight(props.highlight) : m.content}
        </div>
        {attachments > 0 && <div className="lfx-muted">📎 {attachments === 1 ? '1 Anhang' : `${attachments} Anhänge`}</div>}
        <div className="lfx-row" style={{ marginTop: '0.35rem' }}>
          {props.jump !== false && (
            <Link className="lfx-link" to={messageLink(m.serverId, m.channelId, m.id)} data-testid={`${props.testId ?? 'extras-message'}-jump`}>
              Zur Nachricht
            </Link>
          )}
          {props.actions}
        </div>
      </div>
    </article>
  );
}
